import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propChildren, propFunc, propStr, } from '../../../../../../../helpers/custom-prop-types';
import PlusIcon from '../../../../../../Icon/Svg/PlusIcon';
const SeminarOneFormAddButton = (props) => {
    const { className, disabled, onClick, text } = props;
    return (_jsx("div", Object.assign({ className: `professional_seminar_one_form_add_button ${className}` }, { children: _jsxs("button", Object.assign({ className: 'button_inner', disabled: disabled, onClick: onClick, type: 'button' }, { children: [_jsx("span", Object.assign({ className: 'button_icon' }, { children: _jsx(PlusIcon, { className: 'icon_svg' }) })), _jsx("span", Object.assign({ className: 'button_text' }, { children: text }))] })) })));
};
SeminarOneFormAddButton.propTypes = {
    className: propStr(),
    disabled: propBool(),
    onClick: propFunc().isRequired,
    text: propChildren().isRequired,
};
SeminarOneFormAddButton.defaultProps = {
    className: '',
    disabled: false,
};
export default SeminarOneFormAddButton;
